/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { HistoricalBooking } from '../model';
// @ts-ignore
import { PaginatedHistoricalBookingList } from '../model';
/**
 * OrganisationBookingHistoryApi - axios parameter creator
 * @export
 */
export const OrganisationBookingHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Fetch the historical versions of the Bookings ordered latest to oldest.
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingHistoryList: async (bookingId: string, buyerOrgId: string, page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingHistoryList', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingHistoryList', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/history`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Fetch an individual historical version of the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} historyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingHistoryRetrieve: async (bookingId: string, buyerOrgId: string, historyId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingHistoryRetrieve', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingHistoryRetrieve', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'historyId' is not null or undefined
            assertParamExists('orgBookingHistoryRetrieve', 'historyId', historyId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/history/{history_id}`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"history_id"}}`, encodeURIComponent(String(historyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationBookingHistoryApi - functional programming interface
 * @export
 */
export const OrganisationBookingHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationBookingHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Fetch the historical versions of the Bookings ordered latest to oldest.
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingHistoryList(bookingId: string, buyerOrgId: string, page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedHistoricalBookingList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingHistoryList(bookingId, buyerOrgId, page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Fetch an individual historical version of the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} historyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingHistoryRetrieve(bookingId: string, buyerOrgId: string, historyId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HistoricalBooking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingHistoryRetrieve(bookingId, buyerOrgId, historyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganisationBookingHistoryApi - factory interface
 * @export
 */
export const OrganisationBookingHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationBookingHistoryApiFp(configuration)
    return {
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Fetch the historical versions of the Bookings ordered latest to oldest.
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingHistoryList(bookingId: string, buyerOrgId: string, page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedHistoricalBookingList> {
            return localVarFp.orgBookingHistoryList(bookingId, buyerOrgId, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Fetch an individual historical version of the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} historyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingHistoryRetrieve(bookingId: string, buyerOrgId: string, historyId: string, options?: any): AxiosPromise<HistoricalBooking> {
            return localVarFp.orgBookingHistoryRetrieve(bookingId, buyerOrgId, historyId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for orgBookingHistoryList operation in OrganisationBookingHistoryApi.
 * @export
 * @interface OrganisationBookingHistoryApiOrgBookingHistoryListRequest
 */
export interface OrganisationBookingHistoryApiOrgBookingHistoryListRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingHistoryApiOrgBookingHistoryList
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingHistoryApiOrgBookingHistoryList
     */
    readonly buyerOrgId: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OrganisationBookingHistoryApiOrgBookingHistoryList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof OrganisationBookingHistoryApiOrgBookingHistoryList
     */
    readonly pageSize?: number
}

/**
 * Request parameters for orgBookingHistoryRetrieve operation in OrganisationBookingHistoryApi.
 * @export
 * @interface OrganisationBookingHistoryApiOrgBookingHistoryRetrieveRequest
 */
export interface OrganisationBookingHistoryApiOrgBookingHistoryRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingHistoryApiOrgBookingHistoryRetrieve
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingHistoryApiOrgBookingHistoryRetrieve
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingHistoryApiOrgBookingHistoryRetrieve
     */
    readonly historyId: string
}

/**
 * OrganisationBookingHistoryApi - object-oriented interface
 * @export
 * @class OrganisationBookingHistoryApi
 * @extends {BaseAPI}
 */
export class OrganisationBookingHistoryApi extends BaseAPI {
    /**
     * Allow external IDs to be used for generic API views.
     * @summary Fetch the historical versions of the Bookings ordered latest to oldest.
     * @param {OrganisationBookingHistoryApiOrgBookingHistoryListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingHistoryApi
     */
    public orgBookingHistoryList(requestParameters: OrganisationBookingHistoryApiOrgBookingHistoryListRequest, options?: any) {
        return OrganisationBookingHistoryApiFp(this.configuration).orgBookingHistoryList(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Fetch an individual historical version of the Booking
     * @param {OrganisationBookingHistoryApiOrgBookingHistoryRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingHistoryApi
     */
    public orgBookingHistoryRetrieve(requestParameters: OrganisationBookingHistoryApiOrgBookingHistoryRetrieveRequest, options?: any) {
        return OrganisationBookingHistoryApiFp(this.configuration).orgBookingHistoryRetrieve(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.historyId, options).then((request) => request(this.axios, this.basePath));
    }
}
